/**
 * Class description
 *
 * Created: 2018-10-04
 * @author jonas
 */
import {EnvironmentContainer} from "./EnvironmentContainer";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite, TweenLite} from "gsap";
import {DirtyWildColorConfig} from "../../../config/DirtyWildColorConfig";
import {DirtyWildGameMode} from "../../features/DirtyWildsRespinZeroBetController";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {DirtyWildsSpineAnimationNames} from "../../../config/DirtyWildsSpineAnimationNames";


export class EnvironmentSpine extends EnvironmentContainer {
    get spine():PIXI.spine.Spine {
        return this._spine;
    }

    private _spine:PIXI.spine.Spine;
    private _tween:SpineTween;

    private _tintableContainers:PIXI.Container[];


    constructor(name:string, parent:PIXI.Container) {
        super(parent);
        this._spine = new PIXI.spine.Spine(GameResources.getSpineAsset(name));
        this.addChild(this._spine);
    }

    public startLoop():void {
        this._tween = new SpineTween(this._spine, 0, DirtyWildsSpineAnimationNames.ENV_IDLE_LOOP, -1);
    }

    public stopLoop():void {
        this._tween = new SpineTween(this._spine, 0, null);
    }

}